import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Haendler } from '../../../../projects/kiene-core/src/lib/components/stammdaten/haendler/haendler';
import { API_BASE_URL_SERVICE } from '../../../../projects/kiene-core/src/lib/kiene-core.config';
import { KieneTableService } from '../../components/kiene-table/kiene-table.service';
import { DateTableColumn, TableColumn } from '../../components/kiene-table/table-column';
import { TableDescriptor } from '../../components/kiene-table/table-descriptor';
import { TableOption } from '../../components/kiene-table/table-option';
import { EditViehhaendlerDialogComponent } from './edit-viehhaendler-dialog/edit-viehhaendler-dialog.component';

@Component({
    selector: 'kiene-viehhaendler',
    templateUrl: './viehhaendler.component.html',
    styleUrls: ['./viehhaendler.component.scss'],
})
export class ViehhaendlerComponent implements OnInit {
    tableDescriptor: TableDescriptor = new TableDescriptor();

    constructor(
        public dialog: MatDialog,
        @Inject(API_BASE_URL_SERVICE) private readonly apiBaseUrl: string,
        private readonly tableService: KieneTableService,
    ) {}

    ngOnInit() {
        this.tableDescriptor.initialSortColumn = 'bezeichnung';
        this.tableDescriptor.initialSortDirection = 'asc';

        this.tableDescriptor.headline = 'Viehhändler';
        this.tableDescriptor.uniqueIdentifier = 'Viehhändler';
        this.tableDescriptor.apiUrl = this.apiBaseUrl + 'viehhaendler/';
        this.tableDescriptor.route = '/stammdaten/viehhaendler/';
        this.tableDescriptor.nameOfIdField = 'viehhaendler_id';
        this.tableDescriptor.searchPlaceholder = 'Viehhändler durchsuchen';

        this.tableDescriptor.createAllowed = true;
        this.tableDescriptor.standardCreate = false;
        this.tableDescriptor.showDetails = false;

        this.tableDescriptor.columns.push(new TableColumn('viehhaendler_id', 'ID'));
        this.tableDescriptor.columns.push(new TableColumn('name', 'Name'));
        this.tableDescriptor.columns.push(new TableColumn('vvvo', 'VVVO'));
        this.tableDescriptor.columns.push(new TableColumn('strasse', 'Strasse'));
        this.tableDescriptor.columns.push(new TableColumn('plz', 'PLZ'));
        this.tableDescriptor.columns.push(new TableColumn('ort', 'Ort'));
        this.tableDescriptor.columns.push(new TableColumn('telefon', 'Festnetz'));
        this.tableDescriptor.columns.push(new TableColumn('mobil', 'Mobil'));
        this.tableDescriptor.columns.push(new TableColumn('email', 'E-Mail'));
        this.tableDescriptor.columns.push(new TableColumn('fax', 'Fax'));
        this.tableDescriptor.columns.push(new TableColumn('favorit', 'Mein Favorit'));
        this.tableDescriptor.columns.push(new DateTableColumn('editiert', 'Editiert', 'dd.MM.yyyy HH:mm:ss'));

        this.tableDescriptor.permissionView = 9139;
        this.tableDescriptor.permissionCreate = 9132;

        this.tableDescriptor.options.push(new TableOption(this.openEditDialog.bind(this), 'editieren', 'edit', 9133));

        this.tableDescriptor.initialSortColumn = 'viehhaendler_id';
        this.tableDescriptor.initialSortDirection = 'asc';
        this.tableDescriptor.addVoid = this.openEditDialog.bind(this);
    }

    openEditDialog(haendler?: Haendler) {
        if (!haendler) {
            haendler = new Haendler();
        }
        const dialogRef = this.dialog.open(EditViehhaendlerDialogComponent, { data: haendler });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.tableService.reload();
            }
        });
    }
}
